// Scroll to the first matched element
r.prototype.scroll = function() {
    this.first().scrollIntoView({ behavior: 'smooth' });
    return this;
};
